import { useEffect, useState } from 'react';

/**
 * Centralized authentication state hook
 * Manages login state with automatic synchronization across tabs
 * 
 * @returns {Object} Authentication state and utilities
 * @returns {boolean} isLoggedIn - Whether user is currently logged in
 */
export function useAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
    // Initialize from localStorage
    if (typeof window !== 'undefined') {
      return localStorage.getItem('loggedIn') === 'true';
    }
    return false;
  });

  useEffect(() => {
    // Listen for storage events from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'loggedIn') {
        setIsLoggedIn(e.newValue === 'true');
      }
    };

    // Listen for manual storage events from same tab
    const handleManualStorageEvent = (e: Event) => {
      if (e instanceof StorageEvent && e.key === 'loggedIn') {
        setIsLoggedIn(e.newValue === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('storage', handleManualStorageEvent);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('storage', handleManualStorageEvent);
    };
  }, []);

  return { isLoggedIn };
}
